import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import workflowTemplateApi from "../../api/workflowTemplate";
import { selectWorkflowTemplateList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getWorkflowTemplateList(
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectWorkflowTemplateList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.workflowTemplateListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const workflowTemplates = await workflowTemplateApi.getList({
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, workflowTemplates);

      dispatch(
        actions.workflowTemplateListFetchSuccess({
          data: workflowTemplates.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.workflowTemplateListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getWorkflowTemplateListCount(
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectWorkflowTemplateList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.workflowTemplateListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await workflowTemplateApi.getCount({ params, cancelToken });
      cancelToken.throwIfRequested();

      dispatch(actions.workflowTemplateListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.workflowTemplateListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeWorkflowTemplateListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.workflowTemplateListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeWorkflowTemplateListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.workflowTemplateListChangePage(page));
  };
}

export function changeWorkflowTemplateListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.workflowTemplateListChangeFilter(filter));
  };
}

export function workflowTemplateListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectWorkflowTemplateList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.workflowTemplateListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.workflowTemplateListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
